import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { I18nProvider } from "./lib/i18n";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Layout, Spinner } from "./components/site/Layout";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import LessonDetail from "./pages/LessonDetail";
import { Login, Signup } from "./pages/Auth";
import TeacherApply from "./pages/TeacherApply";
import { HowItWorks, ForTeachers, Legal } from "./pages/InfoPages";
import { Checkout, TestPay, PaymentResult, PayLink } from "./pages/Payments";
import { JoinPage, TeacherRoom } from "./pages/LivePages";
import ParentDashboard from "./pages/ParentDashboard";
import TeacherDashboard from "./pages/TeacherDashboard";
import AdminDashboard from "./pages/AdminDashboard";

const Protected = ({ role, children }) => {
  const { user, ready } = useAuth();
  if (!ready) return <Spinner />;
  if (!user) return <Navigate to={`/inloggen?next=${encodeURIComponent(window.location.pathname + window.location.search)}`} replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/lessen" element={<Catalog />} />
              <Route path="/lessen/:id" element={<LessonDetail />} />
              <Route path="/hoe-het-werkt" element={<HowItWorks />} />
              <Route path="/voor-docenten" element={<ForTeachers />} />
              <Route path="/docent-worden" element={<TeacherApply />} />
              <Route path="/inloggen" element={<Login />} />
              <Route path="/aanmelden" element={<Signup />} />
              <Route path="/voorwaarden/ouders" element={<Legal />} />
              <Route path="/voorwaarden/docenten" element={<Legal />} />
              <Route path="/privacy" element={<Legal />} />
              <Route path="/boeken/:id" element={<Protected role="parent"><Checkout /></Protected>} />
              <Route path="/betalen/test/:paymentId" element={<Protected><TestPay /></Protected>} />
              <Route path="/betalen/resultaat/:paymentId" element={<PaymentResult />} />
              <Route path="/betaallink/:token" element={<Protected role="parent"><PayLink /></Protected>} />
              <Route path="/les/:token" element={<JoinPage />} />
              <Route path="/ouder" element={<Protected role="parent"><ParentDashboard /></Protected>} />
              <Route path="/docent" element={<Protected role="teacher"><TeacherDashboard /></Protected>} />
              <Route path="/docent/les/:sessionId" element={<Protected role="teacher"><TeacherRoom /></Protected>} />
              <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
